export default __webpack_public_path__ + "f7974c83771e99703735a3f473f8a505.svg";